import { useState } from 'react';
import { Box, Button, Flex, Heading, IconButton } from '@chakra-ui/react';
import { RiAddFill, RiFilter2Line } from 'react-icons/ri';
import { useAuthContext } from '@contexts/auth';
import Loading from '@components/Loading';
import PaginationRouterContainer from '@components/PaginationRouterContainer';

import useGetList from './useGetList';
import UpsertDialog from './components/UpsertDialog';
import OptionCard from './components/OptionCard';
import Filters from './components/Filters';
import SelectedFiltersList from './components/SelectedFiltersList';

const DispositionOption = () => {
  const { checkIfHasRole } = useAuthContext();

  const [showAddDialog, setShowAddDialog] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const {
    getDispositionOptions,
    dispositionOptions,
    loading,
    totalPages,
  } = useGetList();

  const getCurrentComponent = () => {
    if (loading && dispositionOptions.length === 0) return <Loading />;

    if (!loading && dispositionOptions.length === 0) {
      return (
        <Box textAlign="center" mt={20} color="gray.500">
          Nenhuma opção de tabulação encontrada.
        </Box>
      );
    }

    return (
      <Box opacity={loading ? 0.5 : 1} transition="opacity 0.15s ease">
        <PaginationRouterContainer
          total={totalPages}
        >
          {dispositionOptions.map((option) => (
            <OptionCard
              key={option.id}
              option={option}
              refetch={() => getDispositionOptions({})}
            />
          ))}
        </PaginationRouterContainer>
      </Box>
    );
  }

  return (
    <Box>
      <Flex justifyContent="space-between" alignItems="flex-end" mb={2}>
        <Flex alignItems="center">
          <Heading>Opções de tabulação</Heading>
          <IconButton
            variant="ghost"
            color="argos.fg"
            onClick={() => setShowFilters((prev) => !prev)}
          >
            <RiFilter2Line size={24} />
          </IconButton>
        </Flex>
        {checkIfHasRole('CAN_CREATE_TABULATION_OPTIONS') && (
          <Button size="sm" onClick={() => setShowAddDialog(true)}>
            <RiAddFill /> Novo
          </Button>
        )}
      </Flex>

      {showFilters ? (
        <Filters onClose={() => setShowFilters(false)} />
      ) : (
        <SelectedFiltersList />
      )}

      {getCurrentComponent()}

      {showAddDialog && (
        <UpsertDialog
          handleClose={() => setShowAddDialog(false)}
          afterSubmit={() => getDispositionOptions({})}
        />
      )}
    </Box>
  );
};

export default DispositionOption;
